import { TFunction } from 'i18next';
import { MuiCardBaseProps } from '../components/cards/MuiCard/MuiCardBase/MuiCardBase';

/**
 * Generates an accessible aria-label for document cover links based on content type and title.
 * 
 * @param contentType - The type of content ('product', 'document', 'video', 'course')
 * @param title - Optional title of the content item
 * @param t - Translation function from react-i18next
 * @returns Accessible label string for screen readers
 */
export const getCardAriaLabel = (
  contentType: MuiCardBaseProps['contentType'],
  title: string | undefined,
  t: TFunction
): string => {
  const typeMap = {
    product: 'View product',
    course: 'View course',
    video: 'View video',
    document: 'View document'
  };

  const key = typeMap[contentType] || typeMap.document;
  return title ? t(`${key}: {{title}}`, { title }) : t(key);
};
